module.exports = {"reportingServiceUrl":"https://reporting-service.protransport.dev/","documentServiceUrl":"https://file-service.rtspro.dev/"};